import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutopilotCommand, AutopilotCommandEnum } from '@mocca-technologies/model';

@Component({
  selector: 'app-waypoint-item-tree',
  templateUrl: './waypoint-item-tree.component.html',
  styleUrls: ['./waypoint-item-tree.component.scss']
})
export class WaypointItemTreeComponent {

  @Input() apCommand: AutopilotCommand;
  @Output() editItem: EventEmitter<AutopilotCommand> = new EventEmitter();
  @Output() removeItem: EventEmitter<AutopilotCommand> = new EventEmitter();
  @Output() showItem: EventEmitter<AutopilotCommand> = new EventEmitter();

  constructor() { }

  editWaypointItem(autopilotCommand: AutopilotCommand) {
    autopilotCommand.speed = parseFloat(autopilotCommand.speed.toString());
    autopilotCommand.point.altitude = parseFloat(autopilotCommand.point.altitude.toString());
    autopilotCommand.point.latitude = parseFloat(autopilotCommand.point.latitude.toString());
    autopilotCommand.point.longitude = parseFloat(autopilotCommand.point.longitude.toString());
    this.editItem.emit(autopilotCommand);
    this.showItem.emit(autopilotCommand);
  }

  removeWaypointItem(autopilotCommand: AutopilotCommand) {
    this.removeItem.emit(autopilotCommand);
  }

  showOnMap(autopilotCommand: AutopilotCommand) {
    this.showItem.emit(autopilotCommand);
  }

  isMissionArea(autopilotCommand: AutopilotCommand) {
    if(autopilotCommand.apCommand === AutopilotCommandEnum.MissionArea){
      return true;
    } else {
      return false;
    }
  }

  getTypeIcon(autopilotCommand: AutopilotCommand): string {
    switch (autopilotCommand.apCommand) {
      case AutopilotCommandEnum.Takeoff:      return 'arrow-up-circle-outline';
      case AutopilotCommandEnum.Land:         return 'arrow-down-circle-outline';
      case AutopilotCommandEnum.ForkRoute:    return 'git-branch-outline';
      case AutopilotCommandEnum.JoinRoute:    return 'git-merge-outline';
      case AutopilotCommandEnum.MissionArea:  return 'shapes-outline';
      default:                                return 'radio-button-on-outline';
    }
  }

  isReadOnlyType(autopilotCommand: AutopilotCommand): boolean {
    return autopilotCommand.apCommand === AutopilotCommandEnum.ForkRoute ||
           autopilotCommand.apCommand === AutopilotCommandEnum.JoinRoute;
  }

  canDelete(autopilotCommand: AutopilotCommand): boolean {
    return autopilotCommand.apCommand !== AutopilotCommandEnum.ForkRoute &&
           autopilotCommand.apCommand !== AutopilotCommandEnum.JoinRoute;
  }
}
